var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_vm._t("menu",null,{"handleClick":_vm.handleClick,"handleBlur":_vm.handleBlur,"activeNav":_vm.activeNav,"navReady":_vm.navReady,"slideNav":_vm.slideNav,"resetSecondary":_vm.resetSecondary})],2)}
var staticRenderFns = []

export { render, staticRenderFns }